var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',_vm._b({attrs:{"label":_vm.$t('Paid to account')},model:{value:(_vm.paidToAccount),callback:function ($$v) {_vm.paidToAccount=$$v},expression:"paidToAccount"}},'switch-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }